import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';
import { MeditationCarousel } from '~/src/components/carousels/MeditationCarousel';

import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof MeditationCarousel>['items']) => React.ReactNode;
}
const list = [
  // Noche tranquila	Cristina Herrero
  '4QhP1AXvCM2cMWRZ4IWtz0',
  // Expande tu energía vital	Carla Sánchez
  'lxTrIskXFayF5p51QsTt0',
  // La experiencia del amor puro	Irma González
  '2jj7nVTKAs55h7Eq8Un9bZ',
  // Experimenta la relajación total	Déborah P. Breedveld
  '5PkxV2WnJVjSOPOInz2uoe',
  // El amor que hay en ti	Nichole Golden
  '5bQsntn9dY3Q4tbcKnQoBy',
  // Agradécele a la vida	Michelle Smith
  '13xgkLIMXmZWRNHVFZt63Q',
  // Un descanso total	Cristina Herrero
  '4d44Unr4IcIhGA2dc3C8Tk',
  // Libérate de la negatividad	Marta Pato
  '1c1pAN0r8CmhXtysp2tx82',
  // Diseña tu destino	Nico Luce
  '1km8j45u2EUtjOhdIIBh3e',
  // Activa tu poder personal	Déborah P. Breedveld
  '2US9oZdsSWmZ0BdecKy1hb',
  //Solo fluir
  '5396970',
  // Respira con tranquilidad	Irma González
  'wWNcmXoOwXuv7GEINrcCp',
];

export const MeditaionCarouselDataES: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllMeditaions_LOH_ES>(graphql`
    query Query_AllMeditaions_LOH_ES {
      yi {
        allMeditations(
          filter: {
            ids: [
              "4QhP1AXvCM2cMWRZ4IWtz0"
              "lxTrIskXFayF5p51QsTt0"
              "2jj7nVTKAs55h7Eq8Un9bZ"
              "5PkxV2WnJVjSOPOInz2uoe"
              "5bQsntn9dY3Q4tbcKnQoBy"
              "13xgkLIMXmZWRNHVFZt63Q"
              "4d44Unr4IcIhGA2dc3C8Tk"
              "1c1pAN0r8CmhXtysp2tx82"
              "1km8j45u2EUtjOhdIIBh3e"
              "2US9oZdsSWmZ0BdecKy1hb"
              "5396970"
              "wWNcmXoOwXuv7GEINrcCp"
            ]
          }
        ) {
          ...Fragment_MeditationCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allMeditations;
  if (isNil(data)) {
    return null;
  }
  const sortedClassesData = sortCardsByIds(data, list);

  return <>{children(sortedClassesData)}</>;
};
